export const getErrorArray = (string) => {
  // const  result = []
  const truncated = string?.slice(1, -1)
  return truncated?.split(',')
  // return result
}
